import { Link } from "react-router-dom";

import { useTranslation } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/shared/logo";
import { ROUTES } from "@/lib/constants";

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-ocean-50 p-4">
      <div className="w-full max-w-md rounded-lg border border-ocean-100 bg-white p-8 text-center shadow-sm">
        <div className="mb-6 flex justify-center">
          <Logo size="md" />
        </div>
        <h1 className="text-2xl font-medium text-ocean-800">
          {t("errors.notFound.code")}
        </h1>
        <p className="mt-2 text-sm text-neutral-600">
          {t("errors.notFound.description")}
        </p>
        <Button asChild className="mt-6">
          <Link to={ROUTES.DASHBOARD}>{t("errors.notFound.backHome")}</Link>
        </Button>
      </div>
    </div>
  );
}
